import { Slide } from 'components/UI/V2/Carousel/Slide';

const IMAGE_VIDEO = 'images/sliders/placeholder-video.png';

const rolesOptionsHTML = `
<Box>
    <Box style="margin-bottom: 10px; display: flex; align-items: flex-start;">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="27"><path fill="#92B4A7" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path></svg>
        <Box style="margin-left: 10px;">
            <Box style="font-weight: 600;">Collaborators</Box>
            <Box style="color: #555; font-size: 14px;"> can manage Bookings, Calendar, and Clients.</Box>
        </Box>
    </Box>

    <Box style="margin-bottom: 10px; display: flex; align-items: flex-start;">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="38"><path fill="#92B4A7" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path></svg>
        <Box style="margin-left: 10px;">
            <Box style="font-weight: 600;">Admins</Box>
            <Box style="color: #555; font-size: 14px;"> have full access and control over all account details including financial data.</Box>
        </Box>
    </Box>
</Box>
`;

export const staffSlides: Slide[] = [
    {
        id: 1,
        stepNumber: 1,
        title: 'Add your team and availability.',
        description:
            'Invite your staff to join Cuddles. Simply provide a name and email for each staff member, and we\u2019ll send them an invitation to get started with their own profile.<br/><br/><strong>Solo? Click on your name and set your availability.</strong>',
        image: 'images/sliders/staff/slider-staff-1.jpg',
        videoThumbnail: IMAGE_VIDEO,
        videoTitle: 'How to add a staff?',
        videoDuration: '2:21',
        videoUrl: 'https://www.loom.com/share/78c8303ad9a24684b977c9f6ca7421ad',
        videoMarginTop: '8px'
    },
    {
        id: 2,
        stepNumber: 2,
        title: 'Assign roles & access levels.',
        description: rolesOptionsHTML,
        image: 'images/sliders/staff/slider-staff-2.jpg',
        videoThumbnail: IMAGE_VIDEO,
        videoTitle: 'How to add a staff?',
        videoDuration: '2:21',
        videoUrl: 'https://www.loom.com/share/78c8303ad9a24684b977c9f6ca7421ad',
        videoMarginTop: '4px'
    },
    {
        id: 3,
        stepNumber: 3,
        title: 'Set each staff member\u2019s default schedule.',
        description:
            '<p>Start by adding a default schedule that repeats weekly. You can then adjust it as needed on a week-by-week basis.</p> <p> Don\u2019t skip this step to ensure your team\u2019s availability is accurately reflected for bookings.</p>',
        image: 'images/sliders/staff/slider-staff-3.jpg',
        videoThumbnail: IMAGE_VIDEO,
        videoTitle: 'How to add a default schedule?',
        videoDuration: '0:26',
        videoUrl: 'https://www.loom.com/share/22c988f2456f4002a3980e503435187f',
        videoMarginTop: '8px'
    },
    {
        id: 4,
        stepNumber: 4,
        title: 'Assign the services your staff will perform.',
        description: 'This step is important for keeping availability accurate when scheduling appointments.',
        image: 'images/sliders/staff/slider-staff-4.jpg',
        videoThumbnail: IMAGE_VIDEO,
        videoTitle: 'How to add a Custom Staff Schedule?',
        videoDuration: '0:40',
        videoUrl: 'https://www.loom.com/share/d5272d9cb30043cabbb62be43c954905?t=0',
        videoMarginTop: '24px'
    }
];
